@if (!displayColumn.isValBoolean) {
  @if (displayColumn.rawValue) {
    @if (displayColumn.id.toLowerCase().includes('attachmentcount')) {
      <ng-container [ngTemplateOutlet]="textDisplay" [ngTemplateOutletContext]="{value: displayColumn.listRowValue}"></ng-container>
    } @else if (displayColumn.id.toLowerCase().includes('address')) {
      <ng-container [ngTemplateOutlet]="addressDisplay"
                    [ngTemplateOutletContext]="{coordinates: displayColumn.rawValue?.position?.coordinates, listRowValue: displayColumn.listRowValue}"></ng-container>
    } @else if (displayColumn.id.toLowerCase().includes('depiction')) {
      <div class="symbol-label"
           [style.backgroundImage]="displayColumn.rawValue?.url ? 'url(' + displayColumn.rawValue?.url + ')' : ''"></div>
    } @else if (displayColumn.id.toLowerCase().includes('logo')) {
      <div class="symbol-label"
           [style.backgroundImage]="displayColumn.rawValue?.url ? 'url(' + displayColumn.rawValue?.url + ')' : ''"></div>
    } @else if (displayColumn.id.toLowerCase().includes('headerimage')) {
      <div class="symbol-label"
           [style.backgroundImage]="displayColumn.rawValue?.url ? 'url(' + displayColumn.rawValue?.url + ')' : ''"></div>
    } @else {
      @switch (displayColumn.id) {
        @case ('pool') {
          @if (permissionService.hasPermission(permissionService.Permission.pool_show) && !isInIntegratedContext) {
            <a [pathParams]="[{id: 'poolID', value: displayColumn.rawValue.id}]"
               [sbRouterLink]="RoutingID.devices">
              <ng-container [ngTemplateOutlet]="textDisplay" [ngTemplateOutletContext]="{value: displayColumn.listRowValue}"></ng-container>
            </a>
          } @else {
            <ng-container [ngTemplateOutlet]="textDisplay" [ngTemplateOutletContext]="{value: displayColumn.listRowValue}"></ng-container>
          }
        }
        @case ('channel') {
          @if (permissionService.hasPermission(permissionService.Permission.channel_show) && !isInIntegratedContext) {
            <a [pathParams]="[{id: 'channelID', value: displayColumn.rawValue.id}]"
               [sbRouterLink]="RoutingID.channelDetails">
              <ng-container [ngTemplateOutlet]="textDisplay" [ngTemplateOutletContext]="{value: displayColumn.listRowValue}"></ng-container>
            </a>

          } @else {
            <ng-container [ngTemplateOutlet]="textDisplay" [ngTemplateOutletContext]="{value: displayColumn.listRowValue}"></ng-container>

          }
        }
        @case ('location') {
          @if (permissionService.hasPermission(permissionService.Permission.location_show) && !isInIntegratedContext) {
            <a [pathParams]="[{id: 'locationID', value: displayColumn.rawValue.id}]"
               [sbRouterLink]="RoutingID.locationDetails">
              <ng-container [ngTemplateOutlet]="textDisplay" [ngTemplateOutletContext]="{value: displayColumn.listRowValue}"></ng-container>
            </a>
          } @else {
            <ng-container [ngTemplateOutlet]="textDisplay" [ngTemplateOutletContext]="{value: displayColumn.listRowValue}"></ng-container>
          }
        }
        @case ('currentPosition') {
          <ng-container [ngTemplateOutlet]="addressDisplay"
                        [ngTemplateOutletContext]="{coordinates: displayColumn.rawValue?.data?.coordinates, listRowValue: displayColumn.listRowValue}"></ng-container>
        }
        @case ('lastPairing') {
          @if (displayColumn.rawValue.timestamp) {
            <a class="link cursor-help" container="body"
               ngbTooltip="{{ 'lang.globals.modifiedBy' | translate: { modifiedBy: displayColumn.rawValue?.causedBy?.name ?? ('lang.globals.unknown'|translate) } }}"
               placement="top">{{ displayColumn.rawValue.timestamp.toString() | date: 'dd.MM.yy HH:mm:ss' }}</a>
          } @else {
            <ng-container [ngTemplateOutlet]="textDisplay" [ngTemplateOutletContext]="{value: displayColumn.listRowValue}"></ng-container>
          }
        }
        @default {
          <ng-container [ngTemplateOutlet]="textDisplay" [ngTemplateOutletContext]="{value: displayColumn.listRowValue}"></ng-container>
        }
      }
    }
  } @else {
    <ng-container [ngTemplateOutlet]="textDisplay" [ngTemplateOutletContext]="{value: displayColumn.listRowValue}"></ng-container>
  }
} @else {
  @switch (displayColumn.listRowValue) {
    @case ('true') {
      <sb-icon icon="success" [ngbTooltip]="'true'" container="body" class="cursor-help green"></sb-icon>
    }
    @case ('false') {
      <sb-icon icon="error" [ngbTooltip]="'false'" container="body" class="cursor-help red"></sb-icon>
    }
    @default {
      <sb-icon icon="questionmark" container="body" [ngbTooltip]="'n. def.'" class="cursor-help"></sb-icon>
    }
  }
}


<!-- address display -->
<ng-template #addressDisplay let-coordinates='coordinates' let-listRowValue='listRowValue'>
  @let xCoordinate = coordinates?.[0];
  @let yCoordinate = coordinates?.[1];
  @if (xCoordinate && yCoordinate) {
    <a
      [sbMapTooltip]="{type: 'Coordinates', data: { x: xCoordinate, y: yCoordinate }}"
      class="link"
      container="body"
      ngbTooltip openDelay="300" placement="right left" tooltipClass="widthFix">
      <sb-icon class="mr-2" icon="locationStreet"></sb-icon>
      {{ listRowValue }}
    </a>
  } @else {
    <ng-container [ngTemplateOutlet]="textDisplay"
                  [ngTemplateOutletContext]="{value: listRowValue, length: 90}"></ng-container>
  }
</ng-template>

<!-- default test display -->
<ng-template #textDisplay let-value='value' let-length='length'>
  <sb-value-definition [text]="value" [lengthLimit]="length"></sb-value-definition>
</ng-template>
